export default function PageSoon() {
    return(
        <div>
            <p>Strona w przygotowaniu</p>
        </div>
    )
}